import { FC } from 'react';
import { mergeClasses } from 'shared/utils/mergeClasses';
import { LoadingSpinner } from './LoadingSpinner';

interface PageLoadingSpinnerProps {
  className?: string;
}

export const PageLoadingSpinner: FC<PageLoadingSpinnerProps> = ({ className = '' }) => {
  return (
    <div className={mergeClasses('flex-center fixed z-50 h-screen w-screen bg-white', className)}>
      <LoadingSpinner />
    </div>
  );
};
